import React, { useState, useEffect } from "react";
import AccessGuardProp from "@/@types/AccessGuard";
import { enqueueSnackbar } from "notistack";
import { autorun } from "mobx";

import SignInPage from "@/pages/sign-in";
import Verification from "@/pages/profile/verification";
import PhoneNumberVerifyPage from "@/pages/profile/PhoneNumberVerify";
import Store from "@/store";
import { inject, observer } from "mobx-react";

const AccessGuard = inject(
  Store.type.userStore,
  Store.type.commonStore,
)(
  observer(
    ({
      children,
      userStore,
      commonStore,
      mustVerifiedAccount,
      mustVerifiedPhone,
    }: AccessGuardProp) => {
      const [authenticated, setAuthenticated] = useState(true);
      const [verifiedPhone, setVerifiedPhone] = useState(true);
      const [verifiedAccount, setVerifiedAccount] = useState(true);

      useEffect(() => {
        const checkAccessLevel = () => {
          if (userStore === undefined) {
            return;
          }
          const isLogin = userStore.isLogin;
          const isVerifiedPhone = userStore.isPhoneVerified;
          const isVerifiedAccount = userStore.isAccountVerified;
          if (isLogin !== undefined) {
            setAuthenticated(isLogin);

            if (!isLogin) {
              console.error("Please sign in to access this page.");
              // enqueueSnackbar("Please sign in to access this page.", {
              //   variant: "error",
              // });
            } else {
              if (mustVerifiedPhone && isVerifiedPhone !== undefined) {
                setVerifiedPhone(isVerifiedPhone);

                if (!isVerifiedPhone) {
                  enqueueSnackbar(
                    "Please verify phone number to access this page.",
                    {
                      variant: "error",
                    },
                  );
                  return;
                } else {
                  if (mustVerifiedAccount && isVerifiedAccount !== undefined) {
                    setVerifiedAccount(isVerifiedAccount);

                    if (!isVerifiedAccount) {
                      enqueueSnackbar(
                        "Please verify account to access this page",
                        {
                          variant: "error",
                        },
                      );
                      return;
                    }
                  }
                }
              }
            }
          }
        };

        const disposeAutorun = autorun(checkAccessLevel);

        return () => disposeAutorun();
      }, [userStore]);
      return (
        <>
          {authenticated ? (
            verifiedPhone ? (
              verifiedAccount ? (
                children
              ) : (
                <Verification />
              )
            ) : (
              <PhoneNumberVerifyPage userStore={userStore} />
            )
          ) : (
            userStore !== undefined &&
            commonStore !== undefined && (
              <SignInPage userStore={userStore} commonStore={commonStore} />
            )
          )}
        </>
      );
    },
  ),
);
export default AccessGuard;
